import * as React from 'react';
import { EditableOutlined } from '@duxton-web/icons';
import {
  Alert,
  Button,
  ConfigProvider,
  Table,
  TablePaginationConfig,
} from '@duxton-web/ui';

import { Group } from '../../lib/App';

import './GroupList.css';

export const GroupList = ({
  items,
  onEdit,
  error,
  onPageChange,
  isLoading,
  pagination,
}: {
  items: Group[];
  onEdit: (group: Group) => void;
  error: string;
  onPageChange: (pagination: TablePaginationConfig) => void;
  isLoading: boolean;
  pagination: TablePaginationConfig;
}) => {
  const columns: any[] = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      dataIndex: 'actions',
      key: 'actions',
      width: 50,
      align: 'center',
      render: (_ignored: string, group: Group) => (
        <ConfigProvider
          theme={{
            components: {
              Button: {
                textHoverBg: 'transparent',
              },
            },
          }}
        >
          <div>
            <Button
              size="small"
              data-testid="group-edit-button"
              type="text"
              onClick={() => onEdit(group)}
              icon={<EditableOutlined />}
            />
          </div>
        </ConfigProvider>
      ),
    },
  ];

  return (
    <>
      {error ? (
        <Alert
          message={error}
          type="error"
          closable
          showIcon
          style={{ margin: '1rem 0' }}
        />
      ) : null}

      <Table
        bordered={true}
        columns={columns}
        size="middle"
        rowKey="name"
        dataSource={items}
        showHeader={items?.length > 0}
        pagination={pagination}
        className="grab-x__table"
        rowClassName="group-page"
        loading={isLoading}
        onChange={onPageChange}
        style={{
          border: '1px solid #E8E8E8',
          borderBottomLeftRadius: '0.5rem',
          borderBottomRightRadius: '0.5rem',
          background: 'white',
          position: 'relative',
        }}
      />
    </>
  );
};

export default GroupList;
